import React from 'react';

import { IVideoPlayer } from '@/shared/components/atoms/VideoPlayer/IVideoPlayer';

const VideoPlayer: React.FC<IVideoPlayer.VideoProps> = ({
  src,
  type,
  poster,
  autoplay = false,
  controls = true,
  loop = false,
  muted = true,
}) => {
  return (
    <video
      controls={controls}
      autoPlay={autoplay}
      loop={loop}
      poster={poster}
      className='h-screen w-auto'
      src={src}
      muted={muted}
    >
      <source src={src} type={type} />
      <track src={src} kind='subtitles' srcLang='en' label='English' />
      Your browser does not support the video tag.
    </video>
  );
};

export { VideoPlayer };
